export default __webpack_public_path__ + "static/judanna-27df016315d2a33243cf88ab34b3f4c9.jpg";